






import Vue from 'vue';
import Component from 'vue-class-component';
import {AutocompleteOption} from "../core/interface";

@Component({
    props: [
        'item',
        'searchText'
    ]
})

export default class AutocompleteItem extends Vue {
    item: AutocompleteOption;
    searchText: string;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/v-autocomplete-item.vue